export const defaultMapProvider = {
  id: 'osm',
  name: 'OpenStreetMap',
  tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  center: [16.4637, 107.5909],
  zoom: 5,
  maxZoom: 18,
  boundsPadding: [28, 28],
};
